import {MultipleHeaderAccordion} from "../../../../../components/accordion/MultipleHeaderAccordion";
import React from "react";
import DateUtil from "../../../../../utils/DateUtil";
import RemotingService from "../../../../../services/remoting-service/RemotingService";
import {downloadBlob} from "../../../../../utils/FileDownloader";
import AttachmentUtils from "../../treatment/utils/AttachmentUtils";
import {Column} from "primereact/column";
import ActionMenu from "../../../../../components/action-menu/ActionMenu";
import ActionMenuItem from "../../../../../components/action-menu/ActionMenuItem";
import ViewIcon from "../../../../../components/action-menu/icons/ViewIcon";
import DownloadIcon from "../../../../../components/action-menu/icons/DownloadIcon";
import {DataTable} from "primereact/datatable";
import {Divider} from "@material-ui/core";
import moment from "moment";
import TypeEnum from "../../treatment/enums/result/TypeEnum";
import CommunicationMethod from "../../../../../components/radio-input/CommunicationMethod";

const resultComparatorByDateAsc = (r1, r2) => {
    const d1 = r1.dateOrdered || r1.resultReceived;
    const d2 = r2.dateOrdered || r2.resultReceived;
    if (!d1 && !d2) return 0;
    if (!d1) return 1;
    if (!d2) return -1;
    return moment(d1).diff(moment(d2));
};

const isRadiologyOrLaboratory = (type) => type === 'RADIOLOGY' || type === 'LABORATORY';

export class ResultHistory extends React.Component {

    constructor(props) {
        super(props);

        this.state = {};
    }

    downloadFile(file) {
        RemotingService.instance.get('api/file/download/' + file.uuid, {responseType: 'blob'})
            .then((response) => {
                downloadBlob(new Blob([response.data]), file.name);
            });
    }

    viewFile(file) {
        RemotingService.instance.get('api/file/download/' + file.uuid, {responseType: 'blob'})
            .then((response) => {
                AttachmentUtils.viewFile({
                    fileName: file.name, blob: response.data, id: "attachmentViewer",
                    windowWidth: "1200x", windowHeight: "800px", allowedFileExtensions: null
                });
            });
    }

    render = () => {
        const visit = this.props.visit;

        return <>
            <MultipleHeaderAccordion
                headerText={{firstHeaderText: "Result"}}
                headerExist={{secondHeader: false, thirdHeader: false}}
                defaultExpanded={false}>
                {visit?.treatment?.results?.length > 0 ?
                    <div className="w-100">
                        {[...visit.treatment.results].sort(resultComparatorByDateAsc).map(result =>
                            <div>
                                <div className="row">
                                    <div className="col-2"><b>Type:</b></div>
                                    <div
                                        className="col-8">{result.type ? TypeEnum[result.type].name : ''}</div>
                                </div>
                                {!isRadiologyOrLaboratory(result.type) &&
                                    <div className="row">
                                        <div className="col-2"><b>Details:</b></div>
                                        <div className="col-8">{result.detail}</div>
                                    </div>
                                }
                                <div className="row">
                                    <div className="col-2"><b>Findings:</b></div>
                                    <div className="col-8">{result.findings}</div>
                                </div>
                                <div className="row">
                                    <div className="col-2"><b>Remarks:</b></div>
                                    <div className="col-8">{result.remarks}</div>
                                </div>
                                <div className="row">
                                    <div className="col-2"><b>Date Ordered/Ordered By:</b></div>
                                    <div
                                        className="col-8">{DateUtil.formatDateTimeSeparatelyForReports(result.dateOrdered)} / {result.orderedBy}</div>
                                </div>
                                <div className="row">
                                    <div className="col-2"><b>Result Received:</b></div>
                                    <div
                                        className="col-8">{DateUtil.formatDateTimeSeparatelyForReports(result.resultReceived)}</div>
                                </div>
                                <div className="row">
                                    <div className="col-2"><b>Patient Informed:</b></div>
                                    <div className="col-8">
                                        <CommunicationMethod value={result.patientInformed}
                                                             informedDate={result.informedDate}
                                                             disabled={true}/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <DataTable className="attachmentTable" responsive paginator={true} rows={10}
                                                   emptyMessage={"No results found"}
                                                   value={result.files}
                                                   dataKey="uuid">
                                            <Column style={{width: '145px'}} header="Attachment"
                                                    body={(file) => file.name} sortable/>
                                            <Column style={{width: '50px'}} header="Actions" body={(file) =>
                                                <ActionMenu id="attachmentActionPanel">
                                                    <ActionMenuItem
                                                        icon={<ViewIcon/>}
                                                        onClick={() => {
                                                            this.viewFile(file)
                                                        }} text={"View"}/>
                                                    <ActionMenuItem
                                                        icon={<DownloadIcon/>}
                                                        onClick={() => {
                                                            this.downloadFile(file)
                                                        }} text={"Download"}/>
                                                </ActionMenu>}/>
                                        </DataTable>
                                    </div>
                                </div>
                                <Divider/>
                            </div>
                        )}

                    </div> : <div className="font-italic">No data</div>
                }
            </MultipleHeaderAccordion>
        </>
    }
}
